import React, { useEffect, useState } from "react";
import ClassPerformanceChart from "../../components/ClassPerformanceChart";
import StudentPerformance from "../../components/StudentPerformance";
import ApplicationUsageBarGraph from "../../components/ApplicationUsageBarGraph";
import { performanceData, milestones, applications, applicationTableHeaders, applicationUsageBarGraph, metrics, columns, students, } from "../../components/EducatorProgressbarData";
import MilestoneCompletion from "../../components/MilestoneCompletion";
import KeyMetrics from "../../components/KeyMetrics";
import ApplicationUsageTable from "../../components/ApplicationUsageTable";
import MultiSelectFilter from '../../components/MultiSelectFilter';
import { TrashIcon } from "@heroicons/react/24/outline";
import EducatorExportReport from "../../components/EducatorExportReport";
import Filters from "../../components/MultiSelectFilter";
import { applicationService } from "../../services/applicationService";

function EducatorProgressbar({ permission }) {
  const [openExportReport, setOpenExportReport] = useState(false)
  const [allApplicationListFilter, setAllApplicationListFilter] = useState([])
  const [allSubjectListFilter, setAllSubjectListFilter] = useState([])
  const [selectedFilters, setSelectedFilters] = useState({
    apps: [],
    subject: [],
  });
  const [selectedFiltersIds, setSelectedFiltersIds] = useState({
    apps: "",
    subject: "",
  });
  const filterConfigs = [
    { key: "apps", label: "All Applications", options: allApplicationListFilter, color: "blue" },
    { key: "subject", label: "All Subjects", options: allSubjectListFilter, color: "orange" },
  ];
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    getAllApplicationForFilter()
    getAllSubjectForFilter()
  }, [])

  async function getAllSubjectForFilter() {
    try {
      const response = await applicationService.getAllSubject()
      if (response?.success == true) {
        setAllSubjectListFilter(response?.data)
      } else {
        setAllSubjectListFilter([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }


  async function getAllApplicationForFilter() {
    try {
      const response = await applicationService.getAllApplicationForFilter()
      if (response?.success == true) {
        setAllApplicationListFilter(response?.data)
      } else {
        setAllApplicationListFilter([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }


  return (
    <>
      <div className="space-y-6 p-6">
        <div className='flex items-center justify-between  p-4'>
          <div>
            {/* <MultiSelectFilter /> */}
            <Filters filterConfigs={filterConfigs} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} selectedFiltersIds={selectedFiltersIds} setSelectedFiltersIds={setSelectedFiltersIds} dateRangePicker='true' startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
          </div>
          <div className='flex gap-2'>
            {permission?.export === true &&
              <button onClick={() => setOpenExportReport(true)} className="bg-brandBlue text-white px-3 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition">
                <span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM12 16C11.2044 16 10.4413 15.6839 9.87868 15.1213C9.31607 14.5587 9 13.7956 9 13H4V5H20V13H15C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16ZM16 11H13V14H11V11H8L12 6.5L16 11Z" fill="white" />
                </svg>
                </span> Export  </button>
            }
          </div>
        </div>

        <div className="card">
          <div className="grid md:grid-cols-2 gap-6 p-4">
            <div>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-[#717576]">Performance Trend</h2>
              </div>
              <ClassPerformanceChart data={performanceData} />
            </div>
            <div className="p-4">
              <div>
                <h2 className="text-gray-500 text-[22px] font-semibold mb-4">Key Metrics</h2>
                <KeyMetrics metrics={metrics} />
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 p-4">
            <div>
              <h2 className="text-lg font-semibold mb-4">Milestone Completion</h2>
              <MilestoneCompletion milestones={milestones} />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-gray-500 mb-4">Application Usage</h2>
              <ApplicationUsageBarGraph applicationUsageBarGraph={applicationUsageBarGraph} />
            </div>
          </div>
        </div>

        <div className="card my-4">
          <div className="p-6">
            <div className=" flex justify-between items-center mb-6">
              <h2 className="text-lg font-semibold mb-4">Application Usage</h2>

              <div className="flex justify-end mb-4">
                <input
                  type="text"
                  placeholder="search students..."
                  className="border rounded-lg px-3 py-1 text-sm"
                />
              </div>
            </div>
            <div className=" bg-white p-4">
              <ApplicationUsageTable columns={columns} data={students} />
            </div>
          </div>
        </div>
      </div>
      <EducatorExportReport openExportReport={openExportReport} setOpenExportReport={setOpenExportReport} />
    </>
  );
}

export default EducatorProgressbar;
